// extracted by mini-css-extract-plugin
export var actions = "_gi-g";
export var benefitCard = "_gi-b";
export var benefitIcon = "_gi-d";
export var benefitLabel = "_gi-f";
export var benefits = "_gi-a";
export var benefitsSection = "_gi-8";
export var bodyText = "_gi-7";
export var closeButton = "_gi-2";
export var content = "_gi-3";
export var eyebrow = "_gi-4";
export var heading = "_gi-5";
export var image = "_gi-i";
export var imagePanel = "_gi-h";
export var modal = "_gi-0";
export var offerCard = "_gi-c";
export var offerIcon = "_gi-e";
export var sectionLabel = "_gi-9";
export var shell = "_gi-1";
export var title = "_gi-6";